import { Link } from "react-router-dom";
import { HiOutlineEye } from "react-icons/hi2";
import { getAssetTypeUrl } from "../../utils/assetRoutes";

export const AssetTypeCard = ({ item, isDark }) => {
  const url = getAssetTypeUrl(item.slug, item.type);

  return (
    <div
      className={`box-card asset-type-card min-w-0 pb-4 ${
        isDark ? "card" : "card2"
      }`}
    >
      <div className="p-6 flex flex-col items-center text-center gap-4">
        <div className="w-20 h-20 rounded-full flex items-center justify-center bg-[#0010c6]/10 dark:bg-white/10">
          <img
            src={item.icon}
            alt={item.title}
            className={`w-12 h-12 object-contain brightness-0 saturate-100 ${
              isDark ? "invert" : ""
            }`}
          />
        </div>
        <h3
          className={`text-xl font-bold ${
            isDark ? "text-white" : "text-[#0010c6]"
          }`}
        >
          {item.title}
        </h3>
      </div>

      <div className="px-4">
        <Link to={url} className="block w-full">
          <button
            type="button"
            className={`asset-type-card__btn w-full py-3 rounded-lg flex items-center justify-center gap-2 font-medium border border-solid ${
              isDark
                ? "text-white border-white"
                : "text-[#0010c6] border-[#0010c6]"
            }`}
          >
            <HiOutlineEye className="w-5 h-5" />
            <span>مشاهده</span>
          </button>
        </Link>
      </div>
    </div>
  );
};
